export function imbalanceSocColor(
  imbalanceSoc: number,
  saturation: number = 1,
): string {
  const clamped = Math.max(0, Math.min(0.2, Math.abs(imbalanceSoc)));

  let hue: number;

  if (clamped <= 0.05) {
    // 0% to 5% → Green (120) to Yellow (60)
    hue = 120 - (clamped / 0.05) * 60;
  } else {
    // 5% to 20% → Yellow (60) to Red (0)
    hue = 60 - ((clamped - 0.05) / 0.15) * 60;
  }

  return `hsl(${Math.abs(hue).toFixed(0)}, ${saturation * 100}%, 50%)`;
}
